import { render, staticRenderFns } from "./ShowPDFItem.vue?vue&type=template&id=8428b7de&scoped=true&"
import script from "./ShowPDFItem.vue?vue&type=script&lang=js&"
export * from "./ShowPDFItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=8428b7de&scoped=true&lang=css&"
import style1 from "./ShowPDFItem.vue?vue&type=style&index=1&id=8428b7de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8428b7de",
  null
  
)

export default component.exports